import React from 'react'
import Tooltip from '../Material/Tooltip'
import InfoIcon from '@material-ui/icons/Info'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	icon: {
		position: 'absolute',
		right: 0,
		top: -2,
	}
};

const HelpBox = ({ text, classes }) => {
	if (text == null || text === "") {
		return null;
	}
	else {
		return (
			<Tooltip title={text} placement="top">
				<InfoIcon tabIndex="0" color="disabled" className={classes.icon} />
			</Tooltip>
		)
	}
};

export default withStyles(styles)(HelpBox)



// WEBPACK FOOTER //
// ./src/components/Stompunkt/HelpBox.js